export const NOTIFY_MESSAGE = 'Still there?'
export const NOTIFY_DESCRIPTION = 'You have been inactive for <%= waitingTime %> minutes. Click "Stay signed in" in the next <%= timeToSignOut %> minutes to continue you session or you will be signed out for security reasons.\n Time left: <%= minutes %>m: <%= seconds %>s'
